import RestService from './RestService';

async function query(params) {
    const res = await RestService.performRestOpNext(`general/invoke-authorizer`, {
        service: "GptService",
        method: "invokeGpt",
        params
    });
    return res.choices;
}


const getChatGpt = (type, value, gptOthers) => {
    switch (type) {
        case 'PRODUCT_TITLE':
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as a product title "${value}" result should not be surrounded by quotations and should be less than or equal to a 60 characters hard limit`
                }],
            };

        case "PRODUCT_SEO_TITLE":
            const valSeoTitle = value || gptOthers;
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as a seo product title "${valSeoTitle}" result should not be surrounded by quotations and should be less than or equal to a 60 characters hard limit`
                }],
            };

        case "PRODUCT_SEO_DESCRIPTION":
            const valSeoDesc = value || gptOthers;
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as a seo product description. The result should not be surrounded by quotations and should be less than or equal to a 160 characters hard limit. Text  "${valSeoDesc}"`
                }],
            };

        case 'ARTICLE_TITLE':
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as an article title "${value}" result should not be surrounded by quotations and should be less than or equal to a 60 characters hard limit`
                }],
            };

        case "ARTICLE_SEO_TITLE":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as an article seo title "${value}" result should not be surrounded by quotations and should be less than or equal to a 60 characters hard limit`
                }],
            };

        case "ARTICLE_SEO_DESCRIPTION":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as a seo article description "${value}" result should not be surrounded by quotations and should be less than or equal to a 160 characters hard limit`
                }],
            };

        case "ARTICLE_BODY":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Write an article as html based on the below criteria. 
                    Make sure all points are addressed and they are reader friendly.
                    The generated article should have sections with seo friendly headlines.
                    Highlight important keywords in bold. If there are any links, try to include them
                    ${value}
                    `
                }],
            };

        case "PRODUCT_FEATURED_BULLETS":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please rewrite the following as HTML of a product description with a max heading of h2. Please make it attractive and descriptive. The result doesn't have to be bullet points. If there are links in the original passed HTML, try to include them. Otherwise, don't make up a link or add them as placeholders. Try to break it into several sections. The result should only be HTML. HTML to be rewritten: "${value}"`
                }],
            };

        case "PRODUCT_CONS":
            const valCons = value || gptOthers;
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: value ?
                        `Please rewrite the following as an HTML bullet points of product cons. Make the new text organized and persuasive as cons. The result should only be HTML. If there are links in the original passed HTML, try to include them. 
                        Otherwise, don't make up a link or add them as placeholders. HTML to be rewritten: "${valCons}"` :
                        `Please come up with some cons of the product as HTML bullet points. The result should only be HTML. The Description of the product is "${valCons}", what seems to be a con?`
                }],
            };

        case "PRODUCT_PROS":
            const valPros = value || gptOthers;
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: value ?
                        `Please rewrite the following as an HTML bullet points of product pros. Make the new text organized and persuasive as pros. The result should only be HTML. If there are links in the original passed HTML, try to include them. Otherwise, don't make up a link or add them as placeholders. HTML to be rewritten: "${valPros}"` :
                        `Please come up with some pros as HTML bullet points. The result should only be HTML. HTML to be: "${valPros}"`
                }],
            };

        case "PRODUCT_TAGS":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please come up with one or more single word tags that from that below product description. Tags should return with no quotation, and should be seperated by a comma. Return Maximum of 15 tags, so only return the closest and that are product centeric
                    ${gptOthers}`
                }],
            };

        case "ARTICLE_TAGS":
            return {
                model: "gpt-3.5-turbo",
                messages: [{
                    role: "user",
                    content: `Please come up with one or more single word tags that from that below article description. Tags should return with no quotation, and should be seperated by a comma. Return Maximum of 15 tags, so only return the closest and that are article centeric
                        ${gptOthers}`
                }],
            };
        default:
            return;
    }
}

export default {
    query,
    getChatGpt
}